<template>
    <b-modal ref="modal" :cancel-variant="data.cancelVariant || undefined" :centered="data.centered || false" :dialog-class="dialogClass" :footer-bg-variant="data.footerBgVariant || undefined" :header-bg-variant="data.headerBgVariant || undefined" :header-text-variant="data.headerTextVariant || undefined" :hide-header-close="data.hideHeaderClose || false" :no-close-on-backdrop="data.noCloseOnBackdrop || false" :no-close-on-esc="data.noCloseOnEsc || false" :scrollable="false" body-class="h-100" content-class="h-100" footer-class="d-none" size="xl" title-tag="div" @hidden="onClose" @hide="hide" @shown="onShow">
        <template v-slot:modal-header-close>
            <b-button class="ni ni-close" size="sm" variant="primary" @click="close()" />
        </template>
        <template v-slot:modal-title class="w-100">
            <h5 v-html="modalTitle" />
            <div v-if="data && data.params && data.params.tipo !== 'M'" class="mt-3">
                <div class="input-group">
                    <div v-if="hasImg" class="input-group-prepend pointer" style="cursor: pointer" @click="toggleListImg()">
                        <span v-if="toggledListImg" :title="_trans('list')" class="input-group-text ni ni-grid-view"></span>
                        <span v-else :title="_trans('images')" class="input-group-text ni ni-list-view"></span>
                    </div>
                    <input v-model="filterElement" class="form-control" type="text" />
                    <div class="input-group-append">
                        <span class="input-group-text"><i class="ni ni-search"></i></span>
                    </div>
                    <div class="input-group-append">
                        <button :class="{ active: !hideObsolete }" :title="_trans('view/hide obsolete')" class="btn btn-outline-info" type="button" @click="hideObsolete = !hideObsolete">
                            <i v-if="hideObsolete" class="ni ni-eye-slash"></i>
                            <i v-else class="ni ni-eye"></i>
                        </button>
                    </div>
                </div>
            </div>
        </template>
        <template v-if="data && data.params">
            <div v-if="data.params.tipo !== 'M'" class="row">
                <div v-if="tree && tree.length > 0" class="sidebar col-3">
                    <tree ref="tree" :hide-branch="hideObsolete ? 'obsoleto' : null" :left-arrow-last="true" :selected-node="rootEl" :tree="filteredTree" childs="nodes" label="des" @select="selectTreeItem"></tree>
                </div>
                <div class="content" v-bind:class="{ 'col-9': tree && tree.length > 0, 'col-12': !tree || tree.length < 1 }">
                    <!--IMAGE GRID-->
                    <div v-if="showImg && filteredElements.length > 0" class="my-4 d-flex flex-row flex-wrap justify-content-center">
                        <div v-for="elem in filteredElements" :key="elem.cod" :class="{ 'var-obsolete': elem.enabletype === 2, 'var-deprecated': elem.enabletype === 1 }" :title="elem.des" class="m-2" style="max-width: 150px" @click="selectVariant(elem)">
                            <label-img :active="currentVariant === elem.cod" :color="elem.imgColor" :img="elem.img" height="150px" width="150px">
                                <div class="text-center mt-2 label">
                                    <span :class="{ 'text-primary': currentVariant === elem.cod }" class="text-truncate" v-text="elem.des || '-'"></span>
                                    <span class="text-info text-truncate" v-text="elem.cod"></span>
                                </div>
                            </label-img>
                        </div>
                    </div>
                    <!--LIST-->
                    <div v-else-if="!showImg && filteredElements.length > 0">
                        <table class="table table-hover table-borderless table-responsive">
                            <thead>
                                <tr>
                                    <th class="border-0" width="10%" v-text="_trans('Code')"></th>
                                    <th class="border-0" v-text="_trans('Description')"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(elem, i) in filteredElements" :key="i" :title="elem.des" style="cursor: pointer" @click="selectVariant(elem)">
                                    <td :class="{ 'bg-primary text-white': currentVariant === elem.cod, 'text-muted obsolete': elem.enabletype === 2 }" v-text="elem.cod"></td>
                                    <td :class="{ 'bg-primary text-white': currentVariant === elem.cod, 'text-muted obsolete': elem.enabletype === 2 }" v-text="elem.des"></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <!--EMPTY CONTENT-->
                    <div v-else>
                        <h3 class="text-info text-center p-3 m-0" v-text="_trans('No options')"></h3>
                    </div>
                </div>
            </div>
            <div v-else class="d-flex flex-column">
                <variant :catalog="data.catalog" :variant="data.params" @update="setVariantVal($event)"></variant>
                <div class="d-flex">
                    <b-btn class="ml-auto" @click="confirmVariant" v-text="_trans('Ok')"></b-btn>
                </div>
            </div>
        </template>
        <!--
        <div>
            <pre class="pre-scrollable">
                {{ data }}
            </pre>
        </div>
        -->
    </b-modal>
</template>

<script>
    import { customImport } from "@/utils";
    import { CrulesAPI } from "@3cad/nextcore";
    import modal from "@dialogs/modal.vue";

    let findParentOfNodeInTree = (node, tree) => {
        let parentNode = null;

        for (let i = 0; i < tree.length; i++) {
            let tNode = tree[i];
            if (tNode.cod === node.root) parentNode = tNode;
            else if (tNode.nodes && tNode.nodes.length > 0) parentNode = findParentOfNodeInTree(node, tNode.nodes);

            if (parentNode !== null) break;
        }

        return parentNode;
    };

    let treeSearch = (filter, tree) => {
        if (!filter) return tree;

        // Check filter special char
        filter = filter.replace(/\\/g, "\\\\");
        filter = filter.replace(/\+/g, "\\\+");
        filter = filter.replace(/\*/g, "\\\*");
        filter = filter.replace(/\./g, "\\\.");
        filter = filter.replace(/\?/g, "\\\?");
        filter = filter.replace(/\^/g, "\\\^");
        filter = filter.replace(/\$/g, "\\\$");

        let newTree = [];

        let filterRx = new RegExp(filter, "gi");
        for (let i = 0; i < tree.length; i++) {
            if (tree[i].des && tree[i].des.match(filterRx)) newTree.push(tree[i]);
            else {
                let subTree = null;
                if (tree[i].nodes && tree[i].nodes.length > 0) {
                    subTree = treeSearch(filter, tree[i].nodes);
                }

                if (subTree && subTree.length > 0) {
                    tree[i].nodes = subTree;
                    newTree.push(tree[i]);
                }
            }
        }

        return newTree;
    };

    let treeByFilterLeafs = (tree, leafCodes) => {
        let newTree = [];

        for (let i = 0; i < tree.length; i++) {
            // Option 999 - ciclo contrario perchè l'opzione 999 è sempre all'ultimo posto
            if (!tree[i].cod) {
                let exceptionCode = null;
                for (let j = leafCodes.length - 1; j >= 0; j--) {
                    if (leafCodes[j] === null) {
                        newTree.push(tree[i]);
                        break;
                    }
                }
            } else if (tree[i].cod && leafCodes.indexOf(tree[i].cod) > -1) newTree.push(tree[i]);
            else {
                let subTree = null;
                if (tree[i].nodes && tree[i].nodes.length > 0) {
                    subTree = treeByFilterLeafs(tree[i].nodes, leafCodes);
                }

                if (subTree && subTree.length > 0) {
                    let cpNode = JSON.parse(JSON.stringify(tree[i]));
                    cpNode.nodes = subTree;
                    newTree.push(cpNode);
                }
            }
        }

        return newTree;
    };

    export default {
        mixins: [modal],
        components: {
            labelImg: () => customImport("comp/labelImg.vue"),
            tree: () => customImport("comp/tree.vue"),
            variant: () => customImport("comp/variant.vue")
        },
        data() {
            return {
                response: { type: Object },
                data: { type: Object, default: {} },
                content: {},
                rootEl: {},
                /** Toggle list of images view
                 * true = images
                 * false = list
                 */
                toggledListImg: false,
                filterElement: "",
                hideObsolete: true
            };
        },
        computed: {
            modalTitle() {
                if (this.data && this.data.params) return this.data.title ? this.data.title : `${this._trans("Set variant: ")}<span class="text-info pl-1">${this.data.params.destrad}</span>`;
                else return null;
            },
            hasImg() {
                return this.content.hasimg;
            },
            showImg() {
                return this.hasImg && this.toggledListImg;
            },
            currentVariant() {
                return this.data.params.value;
            },
            tree() {
                return this.content.tree;
            },
            filteredElementBySearchObs() {
                if (!this.content || !this.content.d) return [];

                let filter = this.filterElement;
                let filterRx = null;
                if (filter) {
                    // Check filter special char
                    filter = filter.replace(/\\/g, "\\\\");
                    filter = filter.replace(/\+/g, "\\\+");
                    filter = filter.replace(/\*/g, "\\\*");
                    filter = filter.replace(/\./g, "\\\.");
                    filter = filter.replace(/\?/g, "\\\?");
                    filter = filter.replace(/\^/g, "\\\^");
                    filter = filter.replace(/\$/g, "\\\$");
                    filterRx = new RegExp(filter, "gi");
                }

                return this.content.d.filter(el => {
                    let valid = false;
                    if (!filterRx) valid = true;
                    else valid = el.des.match(filterRx) || el.cod.match(filterRx);

                    // Filter obsolete
                    if (valid && this.hideObsolete) valid = el.enabletype === 0;

                    return valid;
                });
            },
            filteredElements() {
                return this.filteredElementBySearchObs.filter(el => {
                    if (!this.rootEl.cod && this.rootEl.des === "*") return el.cod.match(/^9+$/g) && el.root === null;
                    else if (!this.rootEl.cod) return true;
                    else return el.root === this.rootEl.cod;
                });
            },
            /*filteredElements() {
                if (!this.content || !this.content.d)
                    return false;

                return this.content.d.filter(elem => {
                    if (!this.rootEl.cod && this.rootEl.des === '*') {
                        return elem.cod.match(/^9+$/g) && elem.root === null;
                    } else if (!this.rootEl.cod) {
                        if (this.hideObsolete) {
                            return (elem.enabletype === 0) && (elem.des.toLowerCase().indexOf(this.filterElement.toLowerCase()) > -1 || elem.cod.toLowerCase().indexOf(this.filterElement.toLowerCase()) > -1);
                        } else {
                            return (elem.enabletype === 0 || elem.enabletype === 2) && (elem.des.toLowerCase().indexOf(this.filterElement.toLowerCase()) > -1 || elem.cod.toLowerCase().indexOf(this.filterElement.toLowerCase()) > -1);
                        }
                    } else if (elem.root !== this.rootEl.cod) {
                        return false;
                    }
                    if (this.hideObsolete) {
                        return (elem.enabletype === 0) && (elem.des.toLowerCase().indexOf(this.filterElement.toLowerCase()) > -1 || elem.cod.toLowerCase().indexOf(this.filterElement.toLowerCase()) > -1);
                    } else {
                        return (elem.enabletype === 0 || elem.enabletype === 2) && (elem.des.toLowerCase().indexOf(this.filterElement.toLowerCase()) > -1 || elem.cod.toLowerCase().indexOf(this.filterElement.toLowerCase()) > -1);
                    }
                })
            },*/
            filteredTree() {
                let leafCodes = [];
                for (let i = 0; i < this.filteredElementBySearchObs.length; i++) {
                    if (leafCodes.indexOf(this.filteredElementBySearchObs[i].root) < 0) leafCodes.push(this.filteredElementBySearchObs[i].root);
                }

                return treeByFilterLeafs(this.tree, leafCodes);
            },
            dialogClass() {
                if (this.data.params && this.data.params.tipo == "M") {
                    return "";
                } else return "modal-full modal-search-in-header";
            }
        },
        methods: {
            reset() {
                this.filterElement = "";
                this.rootEl = {};

                if (this.$refs.tree) this.$refs.tree.closeTree();

                this.content = {};
            },
            onClose() {
                this.reset();
            },
            onShow() {
                if (this.data.params.tipo == "M") {
                } else {
                    CrulesAPI.rulePopVariant(this.data.catalog, this.data.params.cod, this.data.extra, json => {
                        this.content = json;
                        if (this.hasImg) this.toggledListImg = this.hasImg;

                        if (this.content.d) {
                            this.content.d.forEach(element => {
                                if (!element.enabletype) element.enabletype = 0; //zero check from the backend
                            });
                        }

                        // Set current variant as visible
                        let curValue = this.data.params.value;
                        let variants = this.content.d;
                        for (let i = 0; i < variants.length; i++) {
                            if (variants[i].cod === curValue) {
                                let tree = this.content.tree;
                                let parentNode = findParentOfNodeInTree(variants[i], tree);
                                if (!parentNode) parentNode = tree[0];
                                this.selectTreeItem(parentNode);
                                break;
                            }
                        }
                    });
                }
            },
            /** Overwrite method
             * @param variant
             */
            selectVariant(variant) {
                this.response.cod = this.data.params.cod;
                this.response.img = variant.img;
                this.response.imgColor = variant.imgColor;
                this.response.value = variant.cod;
                this.response.option = variant;
                this.close(1);
            },
            confirmVariant() {
                this.response.cod = this.data.params.cod;
                // this.response.img = variant.img;
                // this.response.imgColor = variant.imgColor;
                this.response.value = this.data.params.value;
                // this.response.option = this.data.params;
                this.close(1);
            },
            setVariantVal({ cod, value }) {
                this.data.params.value = value;
            },
            /*selectTreeItem(item) {
                this.rootEl = item;
            },*/
            selectTreeItem(data) {
                if (data && data.nodes === null) {
                    this.rootEl = data;
                }
            },
            toggleListImg() {
                this.toggledListImg = !this.toggledListImg;
            }
        }
    };
</script>

<style lang="scss" scoped>
    .modal-content {
        max-height: 100%;

        .modal-header {
            /*display: block;*/
        }

        .modal-body {
            overflow: auto;
            min-height: 100%;
            max-height: 100%;

            .sidebar {
            }

            .content {
                overflow-y: auto;
                min-height: 100%;

                .obsolete {
                    text-decoration: line-through;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/app/dialogs/modalVariant.vue